import CasLink from '../../CasLink/CasLink';
import { ICasMRTCellProps } from './ICasMRTCellProps';

type CasMRTCellRenderLinkProps = ICasMRTCellProps & {
  onClick?: (row: any) => void;
}

export default function CasMRTCellRenderLink({ row, cell, onClick= () => {} }: CasMRTCellRenderLinkProps) {
  const value = cell.getValue();
  return <CasLink onClick={() => onClick(row.original)}>{value}</CasLink>;
}
